import { AppType } from '@repo/types';
import { makeRequest } from './base';

export const getFrontendVersion = (
  appType?: AppType,
): Promise<{ appVersion: string }> => {
  return makeRequest('get', 'api/core/frontend-version', {
    params: {
      appType: appType,
    },
  });
};
